import React, { Fragment, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./ModalComponente.css";
import $ from "jquery";

const ModalComponente = ({
  children,
  id = "",
  titulo = "",
  value = "",
  className = "",
  iconFontSize = "1.5rem",
}) => {
  useEffect(() => {
    const modalElement = document.getElementById(
      `modalModalModalComponente${id}`,
    );
    if (!modalElement) return;

    const handleShown = () => { };

    $(modalElement).on("shown.bs.modal", handleShown);

    return () => {
      $(modalElement).off("shown.bs.modal", handleShown);
    };
  }, [id]);
  return (
    <Fragment>
      <div
        className="componenteModalComponente_container"
        role="button"
        data-toggle="modal"
        data-target={`#modalModalModalComponente${id}`}
      >
        <div style={{ textAlign: "center", marginLeft: "1.5rem" }}>
          <FontAwesomeIcon
            style={{ fontSize: iconFontSize, color: "#25D366" }}
            icon={faWhatsapp}
          />
        </div>
      </div>

      <div
        className="modal fade"
        id={`modalModalModalComponente${id}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`modalModalModalComponente${id}Label`}
        aria-hidden="true"
      >
        <div
          className={
            className
              ? className
              : "modal-dialog modal-dialog-centered modal-lg"
          }
        >
          <div className="modal-content">
            <div className="modal-header componenteModalComponente_headerWhatApp">
              <h5
                className="modal-title"
                id={`modalModalModalComponente${id}Label`}
              >
                {titulo}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body componenteModalComponente_modalBody">
              <div className="componenteModalComponente_bodyContent">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalComponente;
